import React from 'react';

import { Illustration, IllustrationTypes } from '../Illustration';

export enum ToastIllustrationVariant {
  info = 'info',
  success = 'success',
  failure = 'failure',
  warning = 'warning'
}

export type IToastIllustrationVariant = keyof typeof ToastIllustrationVariant;

export interface IToastIllustrationProps {
  className?: string;
  variant: IToastIllustrationVariant;
}

export const ToastIllustration: React.SFC<IToastIllustrationProps> = ({ className, variant }) => (
  <Illustration className={className} illustration={variantMap[variant] as IllustrationTypes} />
);

const variantMap = {
  [ToastIllustrationVariant.info]: 'information',
  [ToastIllustrationVariant.success]: 'success',
  [ToastIllustrationVariant.failure]: 'destruction',
  [ToastIllustrationVariant.warning]: 'warning'
};
